import {createAction, createReducer} from '@reduxjs/toolkit';

import {UpsellType} from 'desktop/pages/success/types/upsellsTypes';

export const initialState = {
    description: '',
    id: 0,
    isActive: false,
    isAdded: false,
    match: '',
    oldPrice: 0,
    price: 0,
    sku: '',
    title: '',
    type: '',
    upsellSku: '',
};

export const setActiveUpsell = createAction<UpsellType>('SUCCESS_PAGE@SET_ACTIVE_UPSELL');

/**
 * Reducer active upsell
 * @param {UpsellType} state - Reducer state
 * @return {UpsellType} New reducer state
 */
export const activeUpsell = createReducer<UpsellType>(initialState, builder => {
    builder.addCase(setActiveUpsell, (state, action) => ({...state, ...action.payload}));
});
